import { Box } from '@mui/material';

import KixieLogoWhite from '../../../images/Kixie-Logo-Full-White.svg';

export const AIOOutcomeKixieLogo = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        mb: '75px',
        paddingLeft: '45px',
      }}
    >
      <Box
        component="img"
        src={KixieLogoWhite}
        alt="Kixie Logo"
        sx={{
          height: 'auto',
          width: { xs: '225px', md: '300px' },
        }}
      />
    </Box>
  );
};
